import script from "./CardNotificación.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardNotificación.vue?vue&type=script&lang=ts&setup=true"

import "./CardNotificación.vue?vue&type=style&index=0&id=7ec94551&lang=css"

const __exports__ = script;

export default __exports__